import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from '@angular/router'
@Injectable({
    providedIn: 'root',
  })
export class HistoryService {
    
    private history: string[]=[]
    constructor(private router: Router) { 
        
    }
    public startSaveHistory():void{
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.history.push(event.urlAfterRedirects)
            }
          })
      }
    
    public getHistory(): string {
        return this.history[0];
    }
  
   
}